export async function releaseExternalShipmentsInProcessUseCase(shipmentInProcessRepository, trace_id) {
    const result = await shipmentInProcessRepository.external_shipments_release(trace_id);

    return result;    
}